<template>
  <v-data-table
    :headers="headers"
    :items="dealers"
    sort-by="customerName"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="customerName"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="billingRangeText"
          label="Billing Range"
          prepend-icon="mdi-calendar"
          readonly
          hide-details
          @click="openDialogBillingRange()"
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>

      <v-dialog v-model="dialogBillingRange"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-date-picker
            v-model="billingRange"
            range
            full-width
          ></v-date-picker>
          <v-card-actions>
            <v-btn
              color="primary"
              plain
              @click="cancelBillingRange()"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="updateBillingRange()"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogBilling"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>Billing</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="dialogBilling = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container fluid>
              <v-data-table
                :items="lols"
                :headers="headersLol"
                :search="searchLol"
                class="elevation-1"
                show-expand
                :expanded.sync="expandedLol"
                :loading="loadingLol"
                
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Search"
                      v-model="searchLol"
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>

                <template v-slot:expanded-item="{ item }">
                  <td colspan="5">
                    <v-container fluid>
                      <v-data-table
                        :items="item.certs"
                        :headers="headersCert"
                      >
                        <template v-slot:item.certificateNumber="props">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                class="subtitle-1"
                                style="border-bottom: 1px dashed #111; cursor: pointer;"
                                @click="$router.push('certificates?certificatenumber=' + props.item.certificateNumber);"
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ props.item.certificateNumber }}
                              </span>
                            </template>
                            <span>Go To Certificate</span>
                          </v-tooltip>
                        </template>

                        <template v-slot:item.certIssueDate="props">
                          {{ props.item.certIssueDate.substring(0, 10) }}
                        </template>
                      </v-data-table>
                    </v-container>
                  </td>
                </template>

                <template v-slot:item.lolNumber="props">
                  <span class="subtitle-1">
                    {{ props.item.lolNumber }}
                  </span>

                  <!-- <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="subtitle-1"
                        style="border-bottom: 1px dashed #111; cursor: pointer;"
                        v-bind="attrs"
                        v-on="on"
                        @click="(item, slot) => slot.expand(!slot.isExpanded)"
                      >
                        {{ props.item.lolNumber }}
                      </span>
                    </template>
                    <span>Expand</span>
                  </v-tooltip> -->

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-2"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="$router.push('lols?lolnumber=' + props.item.lolNumber);"
                      >
                        <v-icon>
                          mdi-location-enter
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Go to LOL</span>
                  </v-tooltip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-menu
                    offset-y
                    transition="slide-y-transition"
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            color="black"
                            icon
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <span>Actions</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item @click="$router.push('lols?lolnumber=' + item.lolNumber);">
                        <v-list-item-action class="mr-4">
                          <v-icon color="">mdi-tablet-cellphone</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Go to LOL</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-bottom-sheet v-model="sheet">
        <v-tabs
          centered
          fixed-tabs
          background-color="cyan"
          dark
          icons-and-text
          v-model="tab"
        >
          <v-spacer></v-spacer>

          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab href="#tab-1">
            Main
            <v-icon>mdi-home-city</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            Billing
            <v-icon>mdi-currency-usd</v-icon>
          </v-tab>

          <v-tab href="#tab-3">
            Technical
            <v-icon>mdi-tools</v-icon>
          </v-tab>

          <v-spacer></v-spacer>

          <v-btn
            class="align-self-center mr-4"
            icon
            dark
            fab
            @click="editMode = !editMode"
            v-if="!editMode && checkRole('lf')"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          
          <v-btn
            class="align-self-center mr-4"
            icon
            dark
            fab
            @click="editMode = !editMode"
            v-if="editMode"
          >
            <v-icon>mdi-pencil-off</v-icon>
          </v-btn>

          <v-btn
            class="align-self-center mr-4"
            icon
            dark
            fab
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-tab-item :key="1" :value="'tab-1'">
            <v-card flat>
              <v-form ref='form'>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="editedItem.customerName"
                        label="Company Name"
                        name="companyName"
                        :rules="rules.required"
                        required
                        hint="Required"
                        persistent-hint
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.mainContact"
                        label="Contact Name"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.mainPhone"
                        label="Phone"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.mainEmail"
                        label="E-mail"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="editedItem.mainAddress"
                        label="Address"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="editedItem.mainAddress2"
                        label="Address 2"
                        hint="Suite, etc..."
                        persistent-hint
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        v-model="editedItem.mainCity"
                        label="City"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.mainState"
                        :items="states"
                        label="State"
                        item-text="state"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        v-model="editedItem.mainZip"
                        label="Postal"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.mainCountry"
                        :items="countries"
                        label="Country"
                        item-text="country"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container>
                  <v-card-actions v-if="checkRole('lf')">
                    <v-spacer></v-spacer>
                    <v-btn @click="close">Cancel</v-btn>
                    <v-btn color="cyan" dark @click="save">Save</v-btn>
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card>
          </v-tab-item>

          <v-tab-item :key="2" :value="'tab-2'">
            <v-card flat>
              <v-form clearable>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.billingContact"
                        label="Contact Name"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.billingPhone"
                        label="Phone"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-model="editedItem.billingEmail"
                        label="E-mail"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="editedItem.billingAddress"
                        label="Address"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="editedItem.billingAddress2"
                        label="Address 2"
                        hint="Suite, etc..."
                        persistent-hint
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        v-model="editedItem.billingCity"
                        label="City"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.billingState"
                        :items="states"
                        label="State"
                        item-text="state"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.billingZip"
                        label="Postal"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.billingCountry"
                        :items="countries"
                        label="Country"
                        item-text="country"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container>
                  <v-card-actions v-if="checkRole('lf')">
                    <v-spacer></v-spacer>
                    <v-btn @click="close">Cancel</v-btn>
                    <v-btn color="cyan" dark @click="save">Save</v-btn>
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card>
          </v-tab-item>

          <v-tab-item :key="3" :value="'tab-3'">
            <v-card flat>
              <v-form clearable>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techContact"
                        label="Contact Name"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techPhone"
                        label="Phone"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techEmail"
                        label="E-mail"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techAddress"
                        label="Address"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techAddress2"
                        label="Address 2"
                        hint="Suite, etc..."
                        persistent-hint
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techCity"
                        label="City"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.techState"
                        :items="states"
                        label="State"
                        item-text="state"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-text-field
                        clearable
                        v-model="editedItem.techZip"
                        label="Postal"
                        color="cyan"
                        :readonly="!editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                    >
                      <v-autocomplete
                        v-model="editedItem.techCountry"
                        :items="countries"
                        label="Country"
                        item-text="country"
                        item-value="abbr"
                        color="cyan"
                        item-color="cyan"
                        :readonly="!editMode"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container>
                  <v-card-actions v-if="checkRole('lf')">
                    <v-spacer></v-spacer>
                    <v-btn @click="close">Cancel</v-btn>
                    <v-btn color="cyan" dark @click="save">Save</v-btn>
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-bottom-sheet>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDelete">Cancel</v-btn>
            <v-btn color="error" dark @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <template v-slot:item.customerName="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.customerName }}
          </span>
        </template>
        <span>Open Billing</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            v-bind="attrs"
            v-on="on"
            @click="$router.push('dealers?customername=' + props.item.customerName);"
          >
            <v-icon>
              mdi-location-enter
            </v-icon>
          </v-btn>
        </template>
        <span>Go to Dealer</span>
      </v-tooltip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-currency-usd</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Open Billing</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('dealers?customername=' + item.customerName);">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-office-building-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Go To Dealer</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import { protectedRoute as routes } from '@/router/config'
  import CustomerService from "../../../services/customer.service";
  import LolService from "../../../services/lol.service";
  import CertService from "../../../services/cert.service";
  import States from "../../../api/state.js"
  import Countries from "../../../api/country.js"
  
  export default {
    data: () => ({
      search: '',
      searchLol: '',
      expandedLol: [],
      selected: [],
      loading: false,
      loadingLol: false,
      sheet: false,
      tab: null,
      dialog: false,
      dialogBillingRange: false,
      dialogBilling: false,
      dialogDelete: false,
      fab: false,
      billingRange: [],
      billingRangeOld: [],
      billingRangeText: '',
      headers: [
        { text: "Company", align: "start", value: "customerName" },
        { text: "LOLs", value: "lolCount" },
        { text: "Certificates", value: "certCount" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      headersLol: [
        { text: "LOL #", align: "start", value: "lolNumber" },
        { text: "Location", value: "location.locationName" },
        { text: "Certificates", value: "certCount" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      headersCert: [
        { text: "Cert #", align: "start", value: "certificateNumber" },
        { text: "Client", value: "client.customerName" },
        { text: "Location", value: "location.locationName" },
        { text: "Source", value: "source.sourceName" },
        { text: "Standard", value: "standard.standardName" },
        { text: "Requested By", value: "requestedBy.fullName" },
        { text: "Issue Date", value: "certIssueDate" },
      ],
      dealers: [],
      lols: [],
      certs: [],
      editedIndex: -1,
      editedItem: {
        customerName: '',
      },
      defaultItem: {
        customerName: '',
      },
      states: States,
      countries: Countries,
      editMode: false,
      rules: {
        required: [
          value => value.length != 0 || 'Required'
        ]
      },
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize() {
        this.checkAuth()
        this.retrieveDealers()
        this.setBillingRange()
      },

      checkAuth() {
        if (!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      async retrieveDealers() {
        this.loading = true
        if (this.checkRole('lf')) {
          await CustomerService.getDealers()
            .then(async response => {
              this.dealers = response.data || []

              for (const dealer of this.dealers) {
                await LolService.getCustomerLols(dealer.customerID)
                  .then(response => {
                    dealer.lolCount = response.data.length

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })
                  .catch(e => {
                    console.log(e)
                  })

                await CertService.getCustomerCertsCreatedBetween(dealer.customerID, this.billingRange[0], this.billingRange[1])
                  .then(response => {
                    dealer.certCount = response.data.length

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })
                  .catch(e => {
                    console.log(e)
                  })
              }
            })
            .catch(e => {
              console.log(e)
              window._LOL2P.$emit('SHOW_SNACKBAR', {
                text: 'There was an error retrieving dealers',
                color: 'error'
              })
            })
        } else {
          await CustomerService.get(this.currentUser.customerID)
            .then(async response => {
              this.dealers = [ response.data ] || []

              for (const dealer of this.dealers) {
                await LolService.getCustomerLols(dealer.customerID)
                  .then(response => {
                    dealer.lolCount = response.data.length

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })
                  .catch(e => {
                    console.log(e)
                  })

                await CertService.getCustomerCertsCreatedBetween(dealer.customerID, this.billingRange[0], this.billingRange[1])
                  .then(response => {
                    dealer.certCount = response.data.length

                    return new Promise(resolve => {
                      resolve('Done')
                    })
                  })
                  .catch(e => {
                    console.log(e)
                  })
              }
            })
            .catch(e => {
              console.log(e)
              window._LOL2P.$emit('SHOW_SNACKBAR', {
                text: 'There was an error retrieving dealers',
                color: 'error'
              })
            })
        }
        this.loading = false
      },

      async createDealer() {
        let customerID = null

        await CustomerService.create(this.editedItem)
          .then(response => {
            this.snackbar("Success! The dealer was created successfully","success")
            customerID = response.data.customerID
            this.dealers.push(this.editedItem)

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e);
            if (e.response && e.response.status === 400) {
              this.snackbar(e.response.data.message, 'error')
            } else {
              this.snackbar('Error! There was an error creating the dealer', 'error')
            }
          })

          return customerID
      },

      updateDealer() {
        CustomerService.update(this.editedItem.customerID, this.editedItem)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The dealer was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'There was an error updating the dealer',
              color: 'error'
            })
          });
      },

      clearSheet() {
        this.editedItem.customerName = ''
        this.editedItem.mainContact = null
        this.editedItem.mainPhone = null
        this.editedItem.mainEmail = null
        this.editedItem.mainAddress = null
        this.editedItem.mainAddress2 = null
        this.editedItem.mainCity = null
        this.editedItem.mainState = null
        this.editedItem.mainZip = null
        this.editedItem.mainCountry = null
        this.editedItem.billingContact = null
        this.editedItem.billingPhone = null
        this.editedItem.billingEmail = null
        this.editedItem.billingAddress = null
        this.editedItem.billingAddress2 = null
        this.editedItem.billingCity = null
        this.editedItem.billingState = null
        this.editedItem.billingZip = null
        this.editedItem.billingCountry = null
        this.editedItem.techContact = null
        this.editedItem.techPhone = null
        this.editedItem.techEmail = null
        this.editedItem.techAddress = null
        this.editedItem.techAddress2 = null
        this.editedItem.techCity = null
        this.editedItem.techState = null
        this.editedItem.techZip = null
        this.editedItem.techCountry = null
        this.editedIndex = -1
        this.tab = 1
        this.editMode= true
      },

      setBillingRange() {
        var date = new Date()
        date.setMonth(date.getMonth() - 1)
        date.setDate(1)
        date.setHours(12)
        date.setMinutes(0)
        date.setSeconds(0)
        date.setMilliseconds(0)
        var date1 = date.toISOString().substring(0, 10)

        date = new Date()
        date.setDate(0)
        date.setHours(12)
        date.setMinutes(0)
        date.setSeconds(0)
        date.setMilliseconds(0)
        var date2 = date.toISOString().substring(0, 10)

        this.billingRange = [date1, date2]
        this.billingRangeText = `${this.billingRange[0].replaceAll('-', '/')} - ${this.billingRange[1].replaceAll('-', '/')}`
      },

      openDialogBillingRange() {
        this.billingRangeOld[0] = this.billingRange[0]
        this.billingRangeOld[1] = this.billingRange[1]
        this.dialogBillingRange = true
      },

      updateBillingRange() {
        if (this.billingRange[0] > this.billingRange[1]) {
          var temp = this.billingRange[0]
          this.billingRange[0] = this.billingRange[1]
          this.billingRange[1] = temp
        }
        this.billingRangeText = `${this.billingRange[0].replaceAll('-', '/')} - ${this.billingRange[1].replaceAll('-', '/')}`
        this.retrieveDealers()
        this.dialogBillingRange = false
      },

      cancelBillingRange() {
        this.billingRange[0] = this.billingRangeOld[0]
        this.billingRange[1] = this.billingRangeOld[1]
        this.dialogBillingRange = false
      },

      async editItem(item) {
        this.loadingLol = true
        this.editedIndex = this.dealers.indexOf(item)
        this.editedItem = Object.assign({}, item)

        await LolService.getCustomerLols(this.editedItem.customerID)
          .then(async response => {
            this.lols = response.data
            console.log(this.lols)

            for (const lol of this.lols) {
              await CertService.getLolCertsCreatedBetween(lol.lolID, this.billingRange[0], this.billingRange[1])
                .then(response => {
                  lol.certs = response.data
                  lol.certCount = response.data.length

                  return new Promise(resolve => {
                    resolve('Done')
                  })
                })
                .catch(e => {
                  console.log(e)
                })
            }

              return new Promise(resolve => {
                resolve('Done')
              })
          })
          .catch(e => {
            console.log(e)
          })
        this.loadingLol = false
        this.dialogBilling = true
      },

      deleteItem(item) {
        this.editedIndex = this.dealers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm() {
        this.dealers.splice(this.editedIndex, 1)
        this.deleteDealer();
        this.closeDelete()
      },

      close() {
        this.sheet = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save() {
        if (!this.$refs.form.validate()) {
          this.snackbar('Error! Missing company name', 'error', '3000')
          return
        }

        if (this.editedIndex > -1) {
          Object.assign(this.dealers[this.editedIndex], this.editedItem);
          this.updateDealer();
        } else {
          this.editedItem.customerID = await this.createDealer()
        }
        this.close()
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>
<style>
@media print{
  .v-toolbar {
    display: none;
  }

  .container {
    padding: 0;
  }

  .v-card__text {
    padding: 0 !important;
  }

  .v-data-table__expanded__content {
    box-shadow: none !important;
  }

  .v-data-table__expanded__content > td {
    padding: 0 !important;
  }

  .v-application .elevation-1 {
    box-shadow: none !important;
  }
}
</style>